module.exports = __webpack_public_path__ + "static/media/description.a4194e84.png";